/*
* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/
export class TaxListResponseModel {
  public taxId: string;
  public title: string;
  public value: string;
  public isActive: number;

  constructor(listResponse: any) {
    this.taxId = listResponse.taxId || '';
    this.title = listResponse.taxName || '';
    this.value = listResponse.taxPercentage || '';
    this.isActive = listResponse.taxStatus || 0;
  }
}
